import axios from 'axios';
import { DocumentFullTextDataModel } from '@/types';

const DocumentFullTextApiUrl = 'DocumentFullText/';

export const DocumentFullTextService = {
  async getAllFullTextAsync(cabinetId: string, documentId: number): Promise<DocumentFullTextDataModel> {
    const response = await axios.get(`${DocumentFullTextApiUrl}${cabinetId}/${documentId}`);
    return response.data;
  },
  async searchAllFullTextAsync(cabinetId: string, documentId: number, fullTextSearch: string)
  : Promise<DocumentFullTextDataModel> {
    const response = await axios.post(DocumentFullTextApiUrl, {
        cabinetId,
        documentId,
        fullTextSearch
      });
    return response.data;
  },
  async getFullTextAsync(cabinetId: string, documentId: number, uniqueId: number): Promise<string> {
    const response = await axios.get(`${DocumentFullTextApiUrl}${cabinetId}/${documentId}/${uniqueId}`);
    return response.data;
  }
};